import { render, staticRenderFns } from "./DoctorFormDetail.vue?vue&type=template&id=50eea4e6&scoped=true"
import script from "./DoctorFormDetail.vue?vue&type=script&lang=js"
export * from "./DoctorFormDetail.vue?vue&type=script&lang=js"
import style0 from "./DoctorFormDetail.vue?vue&type=style&index=0&id=50eea4e6&prod&scoped=true&lang=css"
import style1 from "./DoctorFormDetail.vue?vue&type=style&index=1&id=50eea4e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eea4e6",
  null
  
)

export default component.exports